import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { UEMOA_COUNTRIES } from '../../../core/models/country.model';

@Component({
    selector: 'app-titre-view',
    imports: [
        CommonModule,
        ButtonModule
    ],
    templateUrl: './titre-view.component.html',
    styleUrl: './titre-view.component.scss'
})
export class TitreViewComponent implements OnInit {
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  titre: any;
  emission: any;

  ngOnInit() {
    console.log('TitreViewComponent - config.data:', this.config.data);

    if (this.config.data?.data) {
      this.titre = this.config.data.data;
      console.log('TitreViewComponent - titre:', this.titre);

      this.emission = this.titre.emission;
      console.log('TitreViewComponent - emission:', this.emission);
    }
  }

  getCountryName(code: string): string {
    const country = UEMOA_COUNTRIES.find(c => c.code === code);
    return country?.name || code;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  }

  formatCurrency(value: number): string {
    if (!value) return '0';
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  close() {
    this.ref.close();
  }
}
